import React, { useEffect } from 'react';
import GameResultTable from '../resultTable/GameResultTable';
import ReactGA from 'react-ga';
import { Icon } from 'semantic-ui-react';
import { GA_TRACKING_RESULTS_PAGE } from '../helpers/AppConsts';

const styles = {
  container: {
    minHeight: 'calc(100vh - 200px)',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '25px 30px',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  headerIcon: {
    backgroundColor: '#569556',
    borderRadius: '10px',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    margin: 0,
    fontSize: '1.8rem',
    color: '#333',
  },
  subtitle: {
    margin: 0,
    color: '#666',
    fontSize: '0.95rem',
  },
  tableCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '25px',
  },
};

const Results = () => {
  useEffect(() => {
    ReactGA.ga('send', 'pageview', GA_TRACKING_RESULTS_PAGE);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            <Icon name="trophy" size="large" style={{ color: 'white', margin: 0 }} />
          </div>
          <div>
            <h1 style={styles.title}>Latest Results</h1>
            <p style={styles.subtitle}>Regional bridge competition results</p>
          </div>
        </div>
        <div style={styles.tableCard}>
          <GameResultTable showRows={100} />
        </div>
      </div>
    </div>
  );
};

export default Results;
